import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private roleSubject: BehaviorSubject<string>;
  private quarterSubject: BehaviorSubject<string>;
  private groupSubject: BehaviorSubject<string>;
  private currentQuater: BehaviorSubject<string>;
  private themeSubject: BehaviorSubject<string>;

  constructor() {
    const initialRole = localStorage.getItem('userRole') || 'member';  // Default role is 'guest'
    this.roleSubject = new BehaviorSubject<string>(initialRole);
    this.quarterSubject = new BehaviorSubject<string>('');
    this.currentQuater = new BehaviorSubject<string>('');
    this.groupSubject = new BehaviorSubject<string>('');
    this.themeSubject = new BehaviorSubject<string>('');
  }

  // Observe changes to the role
  get role$(): Observable<string> {
    return this.roleSubject.asObservable();
  }

  get quarter$(): Observable<string> {
    return this.quarterSubject.asObservable();
  }

  get cquarter$(): Observable<string> {
    return this.currentQuater.asObservable();
  }

  get group$(): Observable<string> {
    return this.groupSubject.asObservable();
  }

  get theme$(): Observable<string> {
    return this.themeSubject.asObservable();
  }


  // Method to change the role
  setRole(role: string): void {
    localStorage.setItem('userRole', role);
    this.roleSubject.next(role);  // Notify subscribers about the role change
  }

  setQuarter(q: string): void {
    this.quarterSubject.next(q); 
  }

  setTheme(q: string): void {
    this.themeSubject.next(q); 
  }

  setCurrentQuarter(q: string): void {
    this.currentQuater.next(q); 
  }

  setGroup(q: string): void {
    this.groupSubject.next(q); 
  }
}
